module.exports = __webpack_public_path__ + "img/full6-min.8dd8aa23.png";